import { Locale, type LocalizedString } from "../Locale.js";

export const caseStudiesNameMap = {
	[Locale.cs]: "Případové studie",
	[Locale.en]: "Case studies",
} satisfies LocalizedString;
